module.exports = require('./helpers/bundle-url').getBundleURL('5CuLX') + "logo-dark.eefe0b7f.svg";